export class Provincia {
  constructor(
    public IdProvincia: number,
    public descripcion: string
  ) { }
}

export interface Pais {
  IdPais?: number | string;
  descripcion?: string;
}

export class CodPais {
  constructor(
    public codigo?: string,
    public pais?: string
  ) { }
}

export interface Direccion {
  pais?: Pais;
  provincia?: string;
  localidad?: string;
  codigoPostal?: string;
  calle?: string;
  numero?: number;
  piso?: string;
  departamento?: string;
}
